import type { LatLong } from '@iheartjane/geolocation';
import qs from 'qs';

import { getJwt } from '@jane/shared/auth';
import { createUseQueryHook, janeApi } from '@jane/shared/data-access';
// eslint-disable-next-line no-restricted-imports
import type { Product } from '@jane/shared/models';

export type PurchasedOrTrendingProductsResponse = {
  purchased: Product[];
  trending: Product[];
};

interface PurchasedOrTrendingProductsProps {
  coords?: LatLong;
  userId?: string | number;
}

const fetchPurchasedOrTrendingProducts = ({
  coords,
}: PurchasedOrTrendingProductsProps): Promise<PurchasedOrTrendingProductsResponse> =>
  janeApi.get<PurchasedOrTrendingProductsResponse>(
    `/home?${qs.stringify(coords)}`,
    getJwt()
  );

export const usePurchasedOrTrendingProducts = createUseQueryHook<
  PurchasedOrTrendingProductsProps,
  PurchasedOrTrendingProductsResponse
>(
  fetchPurchasedOrTrendingProducts,
  (props) => ['home', 'products', props.coords, props.userId],
  (props) => !!props.coords || !!props.userId
);
